import {combineReducers} from 'redux';
import {languages} from './states';

function numbers(state = {}, action) {
  switch (action.type) {
    case 'SET_NUMBERS':
      return action.payload || {};
    default:
      return state;
  }
}

const langType = localStorage.getItem('lang') || 'ru';

function language(state = languages[langType], action) {
  if (action.type === 'SWITCH_LANG') {
    return languages[action.payload];
  }
  return state;
}

function alerts(state = false, action) {
  if (action.type === 'SET_NOT_FIND_ALERT') {
    return action.payload;
  }

  if (action.type === 'SEARCH_RESULT_EMPTY_ALERT') {
    return action.payload;
  }

  return state;
}

// function selectedNumber (state = {}, action) {
//   switch (action.type) {
//     case 'SET_SELECTED_NUMBER':
//       return action.number;
//     default:
//       return state;
//   }
// }
function selectedTab(state = 'Простой', action) {
  switch (action.type) {
    case 'SET_SELECTED_TAB':
      return action.tab;
    default:
      return state;
  }
}

function message(state = '', action) {
  switch (action.type) {
    case 'BOOKING_NUMBER':
      return action.payload || '';
    default:
      return state;

  }
}


export default combineReducers({
  numbers,
  language,
  alerts,
  message,
  selectedTab
});
